import { useState } from "react";
import { Button, Text, makeStyles, tokens } from "@fluentui/react-components";
import { Checkmark16Regular, Copy16Regular } from "@fluentui/react-icons";
import { headsUpMessage } from "@gymplan/shared";

const useStyles = makeStyles({
  box: { display: "flex", flexDirection: "column", gap: "8px", padding: "10px 12px", borderRadius: tokens.borderRadiusMedium, backgroundColor: tokens.colorNeutralBackground3, border: `1px solid ${tokens.colorNeutralStroke2}` },
  msg: { whiteSpace: "pre-wrap", fontSize: tokens.fontSizeBase200, lineHeight: tokens.lineHeightBase200, color: tokens.colorNeutralForeground2 },
  row: { display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" },
});

/**
 * The message a trainer sends their clients themselves (from their own WhatsApp, e.g. to the client group)
 * before RackUp messages anyone — so the first message from RackUp isn't from a stranger.
 */
export function HeadsUp({ trainerFirst, rackupNumber, compact }: { trainerFirst: string; rackupNumber?: string | null; compact?: boolean }) {
  const s = useStyles();
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(!compact);
  const text = headsUpMessage(trainerFirst, rackupNumber);
  const copy = () =>
    void navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  return (
    <div className={s.box}>
      <div className={s.row}>
        <Text size={200} weight="semibold" style={{ flex: 1 }}>
          Message to send your clients (e.g. in your client WhatsApp group)
        </Text>
        <Button size="small" appearance="primary" icon={copied ? <Checkmark16Regular /> : <Copy16Regular />} onClick={copy}>
          {copied ? "Copied" : "Copy message"}
        </Button>
        {compact && (
          <Button size="small" appearance="subtle" onClick={() => setOpen((o) => !o)}>
            {open ? "Hide" : "Show"}
          </Button>
        )}
      </div>
      {open && <div className={s.msg}>{text}</div>}
    </div>
  );
}
